module.exports = __webpack_public_path__ + "media/images/home/cours-aerobic-954596d9b9e607778e6cbb2e3cd00cbd.jpg";